import BaseComponent from 'foundation/base-component';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import WeatherWidget from './weather-widget';


class WeatherWidgetComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    render() {
        ReactDOM.render(
            <Fragment>
                <WeatherWidget options={this.options}/>
            </Fragment>,
            this.element
        );
    }
}

export default WeatherWidgetComponent;
